import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "route-table" }
const _hoisted_2 = { class: "route-table__head" }
const _hoisted_3 = { scope: "col" }
const _hoisted_4 = { scope: "col" }
const _hoisted_5 = { scope: "col" }
const _hoisted_6 = { scope: "col" }

import {getTranslations} from "@services/translations";


export default /*@__PURE__*/_defineComponent({
  __name: 'RouteTable',
  props: {
    ticket: {}
  },
  setup(__props: any) {



const translations = getTranslations();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_2, [
          _createElementVNode("th", _hoisted_3, _toDisplayString(_unref(translations)['bookings.routetable.route']), 1 /* TEXT */),
          _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(translations)['bookings.routetable.lowseason']), 1 /* TEXT */),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(translations)['bookings.routetable.peakseason']), 1 /* TEXT */),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(translations)['bookings.routetable.express']), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ticket?.distanceParts, (part) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: part.name
          }, [
            _createElementVNode("td", null, _toDisplayString(part.name), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(part.timeRequiredLowSeason), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(part.timeRequiredHighSeason), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(part.timeRequiredExpress), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}
}

})